import {GET_ROWS_STARTED} from "../../reducers/rowsReducer";

export const getRowsStarted = () =>{
    return {
        type: GET_ROWS_STARTED,
        payload: {}
    }
}